<template>
  <div class="navbar-container">
    <div class="logos-container">
      <div class="gorate-logo-container">
        <img src="../../assets/logos/gorate-logo.svg" alt="gorate-logo">
      </div>
      <div class="customer-logo-container">
        <img src="../../assets/logos/montepio-logo.webp" alt="montepio-logo">
      </div>
    </div>
    <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Dashboard') }" @click="navigate('Dashboard')">
      {{ $t('i18n.dashboard') }}
    </div>
    <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Devices') }" @click="navigate('Devices')">
      {{ $t('i18n.devices') }}
    </div>
    <div class="navbar-item" :class="{ 'active-link': isActiveRoute('Forms') || isActiveRoute('CreateForm') || isActiveRoute('EditForm') }"
      @click="navigate('Forms')">
      {{ $t('i18n.forms') }}
    </div>
    <UserAvatar />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserAvatar from '@/components/misc/UserAvatar.vue'

export default defineComponent({
  name: 'MainNavBar',
  setup () {
    const router = useRouter()
    const route = useRoute()

    return {
      router,
      route
    }
  },
  components: {
    UserAvatar
  },
  data () {
    return {
      isLanguageGroupOpen: false
    }
  },
  methods: {
    navigate (routeName: string) {
      this.router.push({ name: routeName })
    },
    isActiveRoute (routeName: string) {
      return this.route.name === routeName
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/base.scss";
@import "../../styles/colors.scss";

.navbar-container {

  * {
    // All child elements
    padding: 0.3em 0.8em;
  }

  background: $gorate-primary;
  color: $gorate-secondary;

  display: grid;

  grid-template-columns: repeat(4, 1fr) auto;

  justify-items: center;
  align-items: center;

  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.12);

  .logos-container {
    display: grid;
    padding: 0;
    height: 100%;
    background-color: $white;
    justify-self: start;
    width: 70%;
    grid-template-columns: min-content 1fr;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);

    .gorate-logo-container {
      display: grid;
      justify-items: center;
      border-right: 2px solid black;

      img {
        width: 100px;
      }
    }

    .gorate-logo-container,
    .customer-logo-container {
      background-color: $white;
      display: grid;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 0 1rem;
    }

    .customer-logo-container {
      display: grid;
      justify-items: center;

      img {
        justify-self: center;
        width: 170px;
      }
    }
  }

  .navbar-item {
    cursor: pointer;

    &.active-link {
      border-bottom: 4px solid $gorate-secondary;
      font-weight: bold;
    }
  }
}

@media (max-width: 960px) {
    .navbar-container  {
        display: none;
    }
}
</style>
